<template>
    <nav class="side-menu has-sub-site-nav" :class="[ isOpen ? 'open' : 'close' ]" v-on-clickaway="close">
        <div class="side-menu-brand d-xl-none">
            <img class="ruyi-logo align-self-center" src="~@/assets/images/logos/ruyi.svg">
            <button class="close" @click="close">
                <img src="~@/assets/images/close.png">
            </button>
        </div>
        <div class="side-menu-body">
            <ul class="site-nav" @click="close">
                <li class="d-xl-none">
                    <router-link class="link site-nav-link" :to="{ name: `${$i18n.locale}.home` }">{{ $t('pages.home.title') }}</router-link>
                </li>
                <li>
                    <router-link class="link site-nav-link" :to="{ name: `${$i18n.locale}.ruyi` }">{{ $t('pages.ruyi.title') }}</router-link>
                    <ul class="site-nav sub-site-nav">
                        <li>
                            <a class="link site-nav-link" :href="$t('links.company-value.url')">{{ $t('links.company-value.title') }}</a>
                        </li>
                        <li>
                            <a class="link site-nav-link" :href="$t('links.talents.url')">{{ $t('links.talents.title') }}</a>
                        </li>
                        <li>
                            <a class="link site-nav-link" :href="$t('links.social-responsibility.url')">{{ $t('links.social-responsibility.title') }}</a>
                        </li>
                    </ul>
                </li>
                <li>
                    <router-link class="link site-nav-link" :to="{ name: `${$i18n.locale}.technology` }">{{ $t('pages.technology.title') }}</router-link>
                    <ul class="site-nav sub-site-nav">
                        <li>
                            <a class="link site-nav-link" :href="$t('links.rd.url')">{{ $t('links.rd.title') }}</a>
                        </li>
                        <li>
                            <a class="link site-nav-link" :href="$t('links.intelligent-manufacturing.url')">{{ $t('links.intelligent-manufacturing.title') }}</a>
                        </li>
                        <li>
                            <a class="link site-nav-link" :href="$t('links.global-presence.url')">{{ $t('links.global-presence.title') }}</a>
                        </li>
                        <li>
                            <a class="link site-nav-link" :href="$t('links.vertical-integration.url')">{{ $t('links.vertical-integration.title') }}</a>
                        </li>
                    </ul>
                </li>
                <li>
                    <router-link class="link site-nav-link" :to="{ name: `${$i18n.locale}.fashion` }">{{ $t('pages.fashion.title') }}</router-link>
                    <ul class="site-nav sub-site-nav">
                        <li>
                            <router-link class="link site-nav-link" :to="{ name: `${$i18n.locale}.fashion`, hash: '#ruyi-brand-network' }">{{ $t('pages.fashion.text-block-01.title') }}</router-link>
                        </li>
                        <li>
                            <router-link class="link site-nav-link" :to="{ name: `${$i18n.locale}.fashion`, hash: '#smcp' }">SMCP</router-link>
                        </li>
                        <li>
                            <router-link class="link site-nav-link" :to="{ name: `${$i18n.locale}.fashion`, hash: '#renown' }">RENOWN</router-link>
                        </li>
                    </ul>
                </li>
                <li>
                    <router-link class="link site-nav-link" :to="{ name: `${$i18n.locale}.sustainability` }">{{ $t('pages.sustainability.title') }}</router-link>
                    <ul class="site-nav sub-site-nav">
                        <li>
                            <router-link class="link site-nav-link" :to="{ name: `${$i18n.locale}.sustainability`, hash: '#green-energy' }">{{ $t('pages.sustainability.text-block-01.title') }}</router-link>
                        </li>
                        <li>
                            <router-link class="link site-nav-link" :to="{ name: `${$i18n.locale}.sustainability`, hash: '#powering-future' }">{{ $t('pages.sustainability.text-block-02.title') }}</router-link>
                        </li>
                    </ul>
                </li>
                <li class="site-nav-separator d-none d-xl-block"></li>
                <li>
                    <a class="link site-nav-link" :href="$t('links.ruyi-news.url')">{{ $t('links.ruyi-news.title') }}</a>
                </li>
                <li class="d-none d-md-block">
                    <a class="link site-nav-link" :href="$t('links.contact.url')">{{ $t('links.contact.title') }}</a>
                </li>
                <li class="d-xl-none">
                    <button class="link site-nav-link" @click="showSitemapOverlay">{{ $t('pages.sitemap.title') }}</button>
                </li>
            </ul>
            <language-switcher class="d-md-none" />
            <follow-us @click="close" />
            <transition name="stock-info">
                <stock-info class="d-xl-none" v-if="isHome" />
            </transition>
        </div>
    </nav>
</template>

<script>
  import { mapActions, mapGetters, mapState } from 'vuex'

  import FollowUs from './SideMenu/FollowUs'
  import LanguageSwitcher from './SideMenu/LanguageSwitcher'
  import StockInfo from './StockInfo'

  export default {
    computed: {
      ...mapState({
        isOpen: (state) => state.sideMenu.isOpen
      }),
      ...mapGetters([
        'isHome'
      ])
    },
    methods: {
      ...mapActions({
        close: 'closeSideMenu'
      }),
      ...mapActions([
        'showSitemapOverlay'
      ])
    },
    components: {
      FollowUs,
      LanguageSwitcher,
      StockInfo
    }
  }
</script>

<style lang="scss">
    @import '~@/assets/styles/app';

    .side-menu {
        background-color: $white;
        color: #565656;
        height: 100vh;
        font-size: px2rem(15px);
        left: 0;
        position: fixed;
        text-transform: uppercase;
        top: 0;
        transform: translateX(-100%);
        transition: transform .5s ease-in-out;
        width: px2rem(280px);
        z-index: 120;

        @include media-breakpoint-up(xl) {
            font-size: px2rem(16px);
            height: calc(100vh - 110px);
            top: px2rem(110px);
            z-index: 100;
        }

        &-brand {
            border-bottom: 1px solid #ebebeb;
            display: flex;
            height: px2rem(70px);
            justify-content: center;
            position: relative;

            .ruyi-logo {
                width: 45px;
            }

            .close {
                background-color: transparent;
                border: none;
                cursor: pointer;
                left: px2rem(20px);
                padding: px2rem(5px);
                position: absolute;
                top: px2rem(20px);

                > img {
                    display: block;
                    height: 20px;
                    width: 20px;
                }
            }
        }

        &-body {
            background-color: $white;
            height: calc(100% - 70px);
            overflow-y: auto;

            @include media-breakpoint-up(xl) {
                border-right: 2px solid #ebebeb;
                height: 100%;
            }
        }

        .site-nav {
            margin: 0;
            padding: 0;

            &-link {
                border-bottom: 1px solid #ebebeb;
                color: inherit;
                display: block;
                height: px2rem(50px);
                line-height: px2rem(50px);
                text-align: center;
                text-transform: inherit;
                width: 100%;

                @include media-breakpoint-up(xl) {
                    border-bottom: none;
                    height: px2rem(60px);
                    line-height: px2rem(60px);
                }

                &:hover {
                    background-color: #f9f9f9;
                }

                &.exact-active {
                    color: $red;
                }
            }

            &-separator {
                border-top: 2px solid #ebebeb;
                margin: 2rem auto;
                width: px2rem(120px);
            }

            .sub-site-nav {
                background-color: $white;
                border-right: 2px solid #ebebeb;
                bottom: 0;
                display: none;
                left: 0;
                position: absolute;
                top: 0;
                transition: left .5s ease-in-out;
                width: 100%;
                z-index: -1;

                @include media-breakpoint-up(xl) {
                    display: block;
                }
            }

            > li {
                display: block;
                list-style-type: none;

                &:hover .sub-site-nav {
                    @include media-breakpoint-up(xl) {
                        left: px2rem(280px)
                    }
                }
            }

        }

        .stock-info {
            font-size: px2rem(12px);
            margin-left: px2rem(45px);
            margin-top: px2rem(30px);

            &-enter {
                &-active {
                    opacity: 0;
                    transition-duration: .5s;
                }
            }

            &-leave {
                &-active {
                    transition-duration: .5s;
                }
            }
        }

        &.open {
            transform: translateX(0);
        }

        &.close {
            .site-nav {
                @include media-breakpoint-up(xl) {
                    left: 0 !important;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// SideMenu.vue?5799945c